var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 4C4.7835 4 4 4.7835 4 5.75V18.25C4 19.2165 4.7835 20 5.75 20H18.25C19.2165 20 20 19.2165 20 18.25V5.75C20 4.7835 19.2165 4 18.25 4H5.75ZM5.5 5.75C5.5 5.61193 5.61193 5.5 5.75 5.5H18.25C18.3881 5.5 18.5 5.61193 18.5 5.75V18.25C18.5 18.3881 18.3881 18.5 18.25 18.5H5.75C5.61193 18.5 5.5 18.3881 5.5 18.25V5.75ZM15.75 7C15.3358 7 15 7.33579 15 7.75V15.25C15 15.6642 15.3358 16 15.75 16C16.1642 16 16.5 15.6642 16.5 15.25V7.75C16.5 7.33579 16.1642 7 15.75 7ZM7.5 7.75C7.5 7.33579 7.83579 7 8.25 7C8.66421 7 9 7.33579 9 7.75V13.25C9 13.6642 8.66421 14 8.25 14C7.83579 14 7.5 13.6642 7.5 13.25V7.75ZM12 7C11.5858 7 11.25 7.33579 11.25 7.75V11.25C11.25 11.6642 11.5858 12 12 12C12.4142 12 12.75 11.6642 12.75 11.25V7.75C12.75 7.33579 12.4142 7 12 7Z",
    fill: "#B1D1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.dfebd8be3f870206074c0888fefc581c.svg";
export { ForwardRef as ReactComponent };